var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.reloadFlag ? _c("TableComponent") : _vm._e(),
      _c(
        "b-modal",
        {
          staticStyle: { width: "auto" },
          attrs: {
            id: "modal-lg",
            title: "Select Delivery Items",
            centered: "",
            size: "xl",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.saveChanges },
                    },
                    [_vm._v("Save Changes")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end mb-2",
              staticStyle: { position: "relative", "z-index": "1" },
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-danger", size: "sm" },
                  on: { click: _vm.clearFilters },
                },
                [_vm._v(" Clear Filters ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loadingnotes
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.loadingnotes
            ? _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "lg",
                  items: _vm.filteredDeliveryItems,
                  fields: _vm.deliveryItemFieldsModal,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "head(invoiceNo)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Inv #")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Invoice No",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.invoiceNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "invoiceNo", $$v)
                                  },
                                  expression: "filters.invoiceNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(customer)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Customer")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Customer",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.customer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "customer", $$v)
                                  },
                                  expression: "filters.customer",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(itemId)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Product Name")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Product",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.itemId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "itemId", $$v)
                                  },
                                  expression: "filters.itemId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(note)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Note")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Note",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "note", $$v)
                                  },
                                  expression: "filters.note",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(quantity)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Quantity")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Quantity",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "quantity", $$v)
                                  },
                                  expression: "filters.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(address)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Address")]),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: "Search Address",
                                  size: "sm",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.address,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "address", $$v)
                                  },
                                  expression: "filters.address",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "head(status)",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("span", [_vm._v("Status")]),
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.statusOptions,
                                  size: "sm",
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.currentPage = 1
                                  },
                                },
                                model: {
                                  value: _vm.filters.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "status", $$v)
                                  },
                                  expression: "filters.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(invoiceNo)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.item.invoiceNo) + " ")]
                      },
                    },
                    {
                      key: "cell(customer)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.item.customer) + " ")]
                      },
                    },
                    {
                      key: "cell(address)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.item.address) + " ")]
                      },
                    },
                    {
                      key: "cell(itemId)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.getProductName(data.item.itemId)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(quantity)",
                      fn: function (data) {
                        return [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(data.item.quantity)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(check)",
                      fn: function (row) {
                        return [
                          _c("b-form-checkbox", {
                            on: {
                              change: function ($event) {
                                return _vm.logSelectedRow(row.item)
                              },
                            },
                            model: {
                              value: row.item.selected,
                              callback: function ($$v) {
                                _vm.$set(row.item, "selected", $$v)
                              },
                              expression: "row.item.selected",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4192367669
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "mt-3" },
        [
          _c("b-card-header", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center m-1",
              },
              [
                _c("div", { staticClass: "mr-5" }, [
                  _vm._v("Selected Delivery Item Details"),
                ]),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.toggleModal },
                  },
                  [_vm._v("Select Delivery Items")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-card-body",
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.selectedDataItems,
                  fields: _vm.selectedItemFields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(invoiceNo)",
                    fn: function (data) {
                      return [
                        _vm._v(" " + _vm._s(data.item.invoice.invoiceNo) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(customer)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              data.item.invoice.leadClient &&
                                data.item.invoice.leadClient.type == 1
                                ? data.item.invoice.leadClient.companyName
                                : (
                                    (data.item.invoice.leadClient.surname ||
                                      "") +
                                    " " +
                                    (data.item.invoice.leadClient.otherName ||
                                      "")
                                  ).trim()
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(address)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              (data.item.invoice.leadClient.addressLine1 ||
                                "") +
                                " " +
                                (data.item.invoice.leadClient.addressLine2 ||
                                  "")
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(itemId)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getProductName(data.item.itemId)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.getStatusColor(row.item.status),
                            },
                          },
                          [_vm._v(_vm._s(row.item.status))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c(
              "div",
              [
                _c(
                  "validation-observer",
                  {
                    ref: "AddDeliveryForm",
                    on: {
                      ok: function ($event) {
                        $event.preventDefault()
                        return _vm.SubmitDelivery($event)
                      },
                    },
                  },
                  [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.SubmitDelivery($event)
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Vehicle *",
                              "label-for": "vehicle",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "vehicleId",
                                vid: "vehicleId",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "vehicleId",
                                          options: _vm.vehicleOptions,
                                          "value-field": "vehicleId",
                                          "text-field": "make",
                                          state:
                                            errors.length > 0 ? false : null,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.vehicleId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "vehicleId",
                                              $$v
                                            )
                                          },
                                          expression: "delivery.vehicleId",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Driver *", "label-for": "driver" },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "driverId",
                                vid: "driverId",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "driverId",
                                          options: _vm.driverOptions,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.driverId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "driverId",
                                              $$v
                                            )
                                          },
                                          expression: "delivery.driverId",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Pickup Location *",
                              "label-for": "pickUpLocation",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "pickUpLocation",
                                vid: "pickUpLocation",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "pickUpLocation",
                                          options: _vm.locationOptions,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.pickUpLocation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "pickUpLocation",
                                              $$v
                                            )
                                          },
                                          expression: "delivery.pickUpLocation",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Dropoff Location *",
                              "label-for": "dropOffLocation",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "dropOffLocation",
                                vid: "dropOffLocation",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "dropOffLocation",
                                          options: _vm.locationOptions,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.dropOffLocation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "dropOffLocation",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "delivery.dropOffLocation",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Delivery Date *",
                              "label-for": "deliveryDate",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "deliveryDate",
                                vid: "deliveryDate",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "deliveryDate",
                                          type: "date",
                                          min: _vm.currentDate,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.deliveryDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "deliveryDate",
                                              $$v
                                            )
                                          },
                                          expression: "delivery.deliveryDate",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Delivery Status *",
                              "label-for": "deliveryStatus",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "deliveryStatus",
                                vid: "deliveryStatus",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "deliveryStatus",
                                          options: _vm.deliveryStatusOptions,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.delivery.deliveryStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.delivery,
                                              "deliveryStatus",
                                              $$v
                                            )
                                          },
                                          expression: "delivery.deliveryStatus",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          { attrs: { label: "Notes *", "label-for": "notes" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "notes",
                                vid: "notes",
                                rules: "required",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("b-form-textarea", {
                                        attrs: { id: "notes" },
                                        model: {
                                          value: _vm.delivery.notes,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.delivery, "notes", $$v)
                                          },
                                          expression: "delivery.notes",
                                        },
                                      }),
                                      _c(
                                        "small",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(errors[0]))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c("CustomFieldsDetails", {
                          attrs: {
                            AdditionalFields: _vm.delivery.additionalFields,
                            ModuleReference: "Delivery",
                          },
                          on: { onchange: _vm.additionalFieldChanges },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", block: "" },
                            on: {
                              click: function ($event) {
                                return _vm.SubmitDelivery()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v("Save Changes "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }